import {
    Container,
    Typography,
    Box,
    Card,
    CardContent,
    Divider,
    CircularProgress,
    Chip,
} from "@mui/material";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CampaignIcon from "@mui/icons-material/Campaign";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import { useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import config from "../config.json";
import axios from "axios";
import parse from "html-react-parser";

export const ServerNews = () => {
    const apiEndPoint = config.apiEndPoint + "info/server-news";

    const [news, setNews] = useState(null);

    useEffect(() => {
        axios
            .get(apiEndPoint)
            .then((res) => setNews(res.data));
    }, []);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                position: "relative",
                overflow: "hidden",
                py: { xs: 7, md: 10 },
                background:
                    "radial-gradient(ellipse at 50% 0%, rgba(57,217,138,0.12), transparent 42%), linear-gradient(180deg, #06120A 0%, #08160D 52%, #040B06 100%)",
                color: "#FFFFFF",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(57,217,138,0.75), transparent)",
                },
            }}
        >
            {/* BACKGROUND GLOW - TOP RIGHT */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-220px",
                    right: "-220px",
                    width: "550px",
                    height: "550px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.14) 0%, transparent 70%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            {/* BACKGROUND GLOW - BOTTOM LEFT */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: "-250px",
                    left: "-250px",
                    width: "600px",
                    height: "600px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.06) 0%, transparent 70%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* CONTENT */}
            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: { xs: 5, md: 7 },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#39D98A",
                            fontWeight: 800,
                            letterSpacing: {
                                xs: "3px",
                                sm: "5px",
                            },
                            fontSize: "11px",
                            mb: 2,
                            textTransform: "uppercase",
                            textShadow:
                                "0 0 20px rgba(57,217,138,0.2)",
                        }}
                    >
                        CRITICAL CONQUER • ANNOUNCEMENTS
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 900,
                            fontSize: {
                                xs: "42px",
                                sm: "52px",
                                md: "68px",
                            },
                            lineHeight: 1,
                            letterSpacing: "-1.5px",
                            color: "#FFFFFF",
                            mb: 2.5,
                        }}
                    >
                        Latest{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#39D98A",
                                textShadow:
                                    "0 0 30px rgba(57,217,138,0.2)",
                            }}
                        >
                            Updates
                        </Box>
                    </Typography>

                    {/* DECORATIVE EMERALD DIVIDER */}
                    <Box
                        sx={{
                            width: 100,
                            height: 3,
                            mx: "auto",
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #39D98A, #9BFFC4, #39D98A, transparent)",
                            boxShadow:
                                "0 0 18px rgba(57,217,138,0.18)",
                        }}
                    />
                </Box>

                {/* LOADING */}
                {!news ? (
                    <Box
                        sx={{
                            minHeight: "300px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: {
                                xs: "20px",
                                md: "28px",
                            },
                            background:
                                "linear-gradient(145deg, rgba(12,29,19,0.95), rgba(5,14,8,0.98))",
                            border:
                                "1px solid rgba(57,217,138,0.15)",
                            boxShadow:
                                "0 25px 70px rgba(0,0,0,0.35)",
                        }}
                    >
                        <CircularProgress
                            size={42}
                            thickness={3}
                            sx={{
                                color: "#39D98A",
                            }}
                        />

                        <Typography
                            sx={{
                                mt: 3,
                                color: "#8AA092",
                                fontSize: "14px",
                                letterSpacing: "0.3px",
                            }}
                        >
                            Loading server updates...
                        </Typography>
                    </Box>
                ) : news.length === 0 ? (
                    /* EMPTY STATE */
                    <Box
                        sx={{
                            textAlign: "center",
                            py: 10,
                            px: 3,
                            borderRadius: {
                                xs: "20px",
                                md: "28px",
                            },
                            background:
                                "linear-gradient(145deg, rgba(12,29,19,0.98), rgba(5,14,8,0.98))",
                            border:
                                "1px solid rgba(57,217,138,0.16)",
                            boxShadow:
                                "0 20px 60px rgba(0,0,0,0.35)",
                        }}
                    >
                        <CampaignIcon
                            sx={{
                                fontSize: 52,
                                color: "#39D98A",
                                mb: 2,
                                filter:
                                    "drop-shadow(0 0 12px rgba(57,217,138,0.2))",
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#FFFFFF",
                                fontWeight: 800,
                                fontSize: "24px",
                                mb: 1,
                            }}
                        >
                            No Updates Yet
                        </Typography>

                        <Typography
                            sx={{
                                color: "#8AA092",
                                fontSize: "14px",
                                lineHeight: 1.8,
                            }}
                        >
                            There are no announcements to display right now.
                        </Typography>
                    </Box>
                ) : (
                    /* NEWS LIST */
                    <FadeIn>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: { xs: 3, md: 5 },
                            }}
                        >
                            {news.map((e, idx) => (
                                <Card
                                    key={idx}
                                    elevation={0}
                                    sx={{
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: {
                                            xs: "20px",
                                            md: "28px",
                                        },
                                        background:
                                            "linear-gradient(145deg, rgba(12,29,19,0.98) 0%, rgba(5,14,8,0.99) 100%)",
                                        border:
                                            "1px solid rgba(57,217,138,0.15)",
                                        boxShadow:
                                            "0 25px 70px rgba(0,0,0,0.4)",
                                        transition:
                                            "transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease",

                                        "&:hover": {
                                            transform:
                                                "translateY(-4px)",
                                            borderColor:
                                                "rgba(57,217,138,0.35)",
                                            boxShadow:
                                                "0 30px 80px rgba(0,0,0,0.55)",
                                        },
                                    }}
                                >
                                    {/* TOP EMERALD LINE */}
                                    <Box
                                        sx={{
                                            height: "3px",
                                            width: "100%",
                                            background:
                                                "linear-gradient(90deg, transparent, #39D98A, #9BFFC4, #39D98A, transparent)",
                                        }}
                                    />

                                    {/* INNER GLOW */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "-160px",
                                            right: "-160px",
                                            width: "320px",
                                            height: "320px",
                                            borderRadius: "50%",
                                            background:
                                                "radial-gradient(circle, rgba(57,217,138,0.09), transparent 70%)",
                                            filter: "blur(50px)",
                                            pointerEvents: "none",
                                        }}
                                    />

                                    <CardContent
                                        sx={{
                                            position: "relative",
                                            zIndex: 2,
                                            p: {
                                                xs: 3,
                                                sm: 4,
                                                md: 5,
                                            },
                                            "&:last-child": {
                                                pb: {
                                                    xs: 3,
                                                    sm: 4,
                                                    md: 5,
                                                },
                                            },
                                        }}
                                    >
                                        {/* NEWS META */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                justifyContent:
                                                    "space-between",
                                                gap: 2,
                                                mb: 3,
                                            }}
                                        >
                                            <Chip
                                                icon={
                                                    <CampaignIcon
                                                        sx={{
                                                            color:
                                                                "#39D98A !important",
                                                        }}
                                                    />
                                                }
                                                label="Official Announcement"
                                                sx={{
                                                    height: 34,
                                                    background:
                                                        "rgba(57,217,138,0.08)",
                                                    color: "#9BFFC4",
                                                    border:
                                                        "1px solid rgba(57,217,138,0.2)",
                                                    fontWeight: 800,
                                                    fontSize: "11px",
                                                    borderRadius: "10px",

                                                    "& .MuiChip-label": {
                                                        px: 1.5,
                                                    },
                                                }}
                                            />

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                <AccessTimeIcon
                                                    sx={{
                                                        fontSize: 17,
                                                        color: "#39D98A",
                                                    }}
                                                />

                                                <Typography
                                                    sx={{
                                                        color:
                                                            "rgba(220,255,232,0.5)",
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {new Date(
                                                        e.date
                                                    ).toLocaleString()}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* NEWS TITLE */}
                                        <Typography
                                            sx={{
                                                color: "#FFFFFF",
                                                fontWeight: 900,
                                                fontSize: {
                                                    xs: "27px",
                                                    sm: "32px",
                                                    md: "40px",
                                                },
                                                lineHeight: 1.2,
                                                letterSpacing: "-0.7px",
                                                mb: 3,
                                                overflowWrap: "anywhere",
                                            }}
                                        >
                                            {e.title}
                                        </Typography>

                                        {/* DIVIDER */}
                                        <Divider
                                            sx={{
                                                mb: 3,
                                                borderColor:
                                                    "rgba(255,255,255,0.07)",
                                            }}
                                        />

                                        {/* NEWS CONTENT */}
                                        <Box
                                            sx={{
                                                color:
                                                    "rgba(230,242,234,0.76)",
                                                fontSize: {
                                                    xs: "15px",
                                                    md: "16px",
                                                },
                                                lineHeight: 1.9,
                                                overflowWrap: "anywhere",

                                                "& p": {
                                                    marginTop: 0,
                                                    marginBottom: 2,
                                                },

                                                "& p:last-child": {
                                                    marginBottom: 0,
                                                },

                                                "& strong": {
                                                    color: "#9BFFC4",
                                                    fontWeight: 800,
                                                },

                                                "& h1, & h2, & h3, & h4": {
                                                    color: "#FFFFFF",
                                                    fontWeight: 800,
                                                    marginTop: 3,
                                                    marginBottom: 2,
                                                },

                                                "& ul, & ol": {
                                                    paddingLeft: 3,
                                                    marginBottom: 2,
                                                },

                                                "& li": {
                                                    marginBottom: 1,
                                                },

                                                "& a": {
                                                    color: "#39D98A",
                                                    fontWeight: 700,
                                                    textDecorationColor:
                                                        "rgba(57,217,138,0.4)",
                                                    transition:
                                                        "color 0.2s ease",

                                                    "&:hover": {
                                                        color: "#9BFFC4",
                                                    },
                                                },

                                                "& img": {
                                                    display: "block",
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    borderRadius: "16px",
                                                    marginTop: 3,
                                                    marginBottom: 3,
                                                    border:
                                                        "1px solid rgba(57,217,138,0.18)",
                                                    boxShadow:
                                                        "0 15px 40px rgba(0,0,0,0.35)",
                                                },

                                                "& blockquote": {
                                                    margin: "24px 0",
                                                    padding:
                                                        "16px 20px",
                                                    borderLeft:
                                                        "3px solid #39D98A",
                                                    background:
                                                        "rgba(57,217,138,0.05)",
                                                    color: "#C7D9CD",
                                                    borderRadius:
                                                        "0 12px 12px 0",
                                                },

                                                "& table": {
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                    borderCollapse:
                                                        "collapse",
                                                },

                                                "& th, & td": {
                                                    padding:
                                                        "10px 12px",
                                                    border:
                                                        "1px solid rgba(57,217,138,0.14)",
                                                    textAlign: "left",
                                                },

                                                "& th": {
                                                    color: "#9BFFC4",
                                                    background:
                                                        "rgba(57,217,138,0.05)",
                                                },
                                            }}
                                        >
                                            {parse(e.content)}
                                        </Box>

                                        {/* BOTTOM BRAND ACCENT */}
                                        <Box
                                            sx={{
                                                mt: 4,
                                                pt: 3,
                                                borderTop:
                                                    "1px solid rgba(255,255,255,0.06)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent:
                                                    "space-between",
                                                gap: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: "#557060",
                                                    fontSize: "10px",
                                                    fontWeight: 800,
                                                    letterSpacing: {
                                                        xs: "1px",
                                                        sm: "2px",
                                                    },
                                                    textTransform:
                                                        "uppercase",
                                                }}
                                            >
                                                Critical Conquer
                                            </Typography>

                                            <ArrowForwardRoundedIcon
                                                sx={{
                                                    fontSize: 20,
                                                    color:
                                                        "rgba(57,217,138,0.65)",
                                                    transition:
                                                        "transform 0.25s ease",

                                                    "&&:hover": {
                                                        transform:
                                                            "translateX(4px)",
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </FadeIn>
                )}
            </Container>
        </Box>
    );
};

export default ServerNews;